import {
  Box,
  ComponentMultiStyleConfig,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";

export type CMPageNumberAndSearchResultProps = {
  /**
   * ページ番号のラベル
   */
  labelPageNumber?: string;

  /**
   * 現在のページ番号
   */
  currentPageNumber: number;

  /**
   * 区切り用ラベル
   */
  labelOf?: string;

  /**
   * 総検索結果件数
   */
  totalElements: number;

  /**
   * 検索結果のラベル
   */
  labelSearchResult?: string;
} & ComponentStyleProps;

/**
 * 検索結果数とページ番号コンポーネント.
 */
export const CMPageNumberAndSearchResult = ({
  labelPageNumber = "Page",
  currentPageNumber,
  labelOf = "of",
  totalElements,
  labelSearchResult = "results",

  sx,
  ...rest
}: CMPageNumberAndSearchResultProps) => {
  const styles = useMultiStyleConfig("CMPageNumberAndSearchResultStyles", {});

  return (
    <Box {...rest} sx={{ ...styles.container, ...sx }}>
      <Text>{labelPageNumber}</Text>
      <Text>{currentPageNumber}</Text>
      <Text>{labelOf}</Text>
      <Text>{totalElements}</Text>
      <Text>{labelSearchResult}</Text>
    </Box>
  );
};

export const CMPageNumberAndSearchResultStyles: ComponentMultiStyleConfig = {
  parts: ["container", "label"],
  baseStyle: {
    container: {
      display: "flex",
      columnGap: "4px",
      alignItems: "center",
      fontSize: "14px",
      lineHeight: "18px",
      color: "gray.500",
    },
    label: {},
  },
};
